<template>
    <!--SIGN IN PAGE-->
    <ThePageExternal :title="'SIGNIN__TITLE'"
                     :className="'SignInView'">
        <!--EMAIL-->
        <BaseText :label="'SIGNIN__EMAIL'"
                  :value="email"
                  :errors="errors['email']"
                  :autofocus="true"
                  :icon="'icon-mail'"
                  @change="setEmail($event.target.value)" 
                  @enter="signin()"/>

        <!--PASSWORD-->
        <BaseText :label="'SIGNIN__PASSWORD'"
                  :value="password"
                  :errors="errors['password']"
                  :icon="'icon-lock'"
                  :password="true"
                  @change="setPassword($event.target.value)"
                  @enter="signin()"/>
        <div class="SignInView__actions">

            <!--FORGOT PASSWORD?-->
            <BaseButtonFlat :label="'SIGNIN__FORGOT_PASSWORD'"
                            :class-name="'SignInView__forgot-password'"
                            @click="openForgotPassword()" />

            <!--NEED ACCOUNT?-->
            <BaseButtonFlat :label="'SIGNIN__NEED_ACCOUNT'"
                            :class-name="'SignInView__need-account'"
                            @click="openSignUp()" />
        </div>

        <!--SIGN IN-->
        <BaseButton :label="'SIGNIN__SIGN_IN'"
                    @click="signin($event.target)" />

        <!--BOTTOM TEXT-->
        <div class="SignInView__bottom">
            {{appName}} {{(new Date()).getFullYear()}}
        </div>
    </ThePageExternal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    import ThePageExternal from '../components/common/ThePageExternal.vue';
    import BaseText from '../components/common/BaseText.vue';
    import BaseButton from '../components/common/BaseButton.vue';
    import BaseButtonFlat from '../components/common/BaseButtonFlat.vue';
    import constants from '../store/constants';

    export default {
        name: 'SignInView',
        components: {
            ThePageExternal,
            BaseText,
            BaseButton,
            BaseButtonFlat
        },
        computed: {
            ...mapState({
                email: s => s.signin.email,
                password: s => s.signin.password,
                errors: s => s.signin.errors
            }),
            appName: () => constants.appName
        },
        methods: {
            ...mapActions({
                signin: 'signin/signin',
                openForgotPassword: 'signin/openForgotPassword',
                openSignUp: 'signin/openSignUp',

                //Setters
                setEmail: 'signin/setEmail',
                setPassword: 'signin/setPassword'
            })
        }
    };
</script>

<style>
    .SignInView {
        width: 360px;
        max-height: 378px;
    }

    .SignInView__actions {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .BaseButtonFlat.SignInView__forgot-password {
        padding: 8px;
        font-size: 12px;
        color: #546E7A;
    }

    .BaseButtonFlat.SignInView__need-account {
        padding: 8px;
        font-size: 12px;
    }

    .SignInView__bottom {
        font-family: 'Voltaire';
        text-align: center;
        margin: 20px;
        color: rgba(0,0,0,.5);
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// SignInView.vue?10ef4507